import { useGetTeamQuery } from "../../redux/features/Team/teamApi"


export default function TeamMembers(){
    const {data: team, isLoading, isError} = useGetTeamQuery();

    // decide what to render
    let content = null;
    if(isLoading){content=  <div>Loading....</div>}
    else if(!isLoading && isError){content=  <div>There was an error occurred</div> }
    else if(!isLoading && !isError && team?.length <= 0){content=  <div>Team not found</div> }
    else if(!isLoading && !isError && team?.length > 0){
       content=  team.map(item=>{
        const {name, avatar, id} = item || {};
      return <div key={id} className="checkbox-container">
       <img src={avatar} className="team-avater" alt={name}/>
       <p className="label">{name}</p>
     </div>})
    }


  return(
    <div className="mt-8">
        <h3 className="text-xl font-bold">Team Members</h3>
        <div className="mt-3 space-y-4">
            {content}
        </div>
      </div>
  )};